// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorsList_root_BmyH5","errorWrap":"ErrorsList_errorWrap_xa6JA","closeBtn":"ErrorsList_closeBtn_1kEnC","error":"ErrorsList_error_2Kymb"};